// Función helper que detecta qué campos tiene
function getValueFields(measure) {
    if (measure.avg !== undefined && measure.max !== undefined && measure.min !== undefined) {
        return ['avg', 'max', 'min']; // Daily
    }
    return ['y']; // Realtime
}

// Función genérica que aplica operaciones
function applyOperation(measures, operationFn) {
    if (measures.length === 0) return;

    // Detecta la estructura del primer elemento
    const fields = getValueFields(measures[0]);

    for (let d = 0; d < measures.length; d++) {
        fields.forEach(field => {
            if (measures[d][field]) {
                measures[d][field] = operationFn(measures[d][field]);
            }
        });
    }
}

// VB - Sin parámetros adicionales
export function operationForChangeVbValue(measuresVb) {
    const operation = (value) => {
        if (value > 3) {
            return Math.round(((value - 3) / 1.25) * 100 * 100) / 100;
        }
        return 0;
    };

    applyOperation(measuresVb, operation);
}

// CE - Sin parámetros adicionales
export function operationForChangeCeValue(measuresCE, idSensor) {
    let sensorChange = ['SN0010', 'SN0011', 'SN0015', 'SN0024', 'SN0028', 'SN0031', 'TR0001'];

    if (sensorChange.includes(idSensor)) {
        applyOperation(measuresCE, (value) =>
            parseFloat((value * 10).toFixed(2))
        );
    }    
}

// PH - Sin parámetros adicionales
export function operationForChangePhValue(measurePH, idSensor) {
    let sensorChange = ['SN0031', 'TR0001'];

    if (sensorChange.includes(idSensor)) {
        applyOperation(measurePH, (value) =>
            parseFloat((value * 10).toFixed(2))
        );
    }
}


export function operationForAdaptDailyValue(measures) {
    for (let d = 0; d < measures.length; d++)
        measures[d].y = measures[d].avg;
}